import { canSaveToLibrary } from '../../../../utils/permissions';
import { Divider } from 'antd';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import { Icon } from '../../../../components/icon/icon';
import './NavbarDesign.scss';
import { CSSTransition } from 'react-transition-group';
import { useContext } from 'react';
import { DesignerPageContext } from '../../DesignerPage';
import Tooltip from '../../../../components/common/Tooltip/Tooltip';
import ButtonSecondaryMedium from '../../../../components/common/ButtonSecondary/ButtonSecondaryMedium';
import { useSelector } from 'react-redux';
import { InsideType } from '../../../../constants/enum';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../../utils/string/cn.utils';

const NavbarDesign = ({ activeKey, setActiveKey, show }) => {
  const { user, isLoading } = useSelector(state => state.auth);
  const {
    sceneManager,
    selectedModel,
    setSelectedModel,
    selectedModels,
    setSelectedModels,
    cabinetType,
    setTick,
    showCabinetEditor,
    setShowSaveLibraryModule,
    meshClickRef,
    sceneRef,
    insideLoaderRef,
    childClickRef,
    setShowNavDesign,
  } = useContext(DesignerPageContext);

  const { t } = useTranslation();

  if (!sceneManager) return;
  const positionController = sceneManager.positionController;

  const items =
    cabinetType === 'kitchen'
      ? [
          {
            icon: <Icon.ICDesign />,
            key: '2',
            onClick: null,
            tooltip: t('Structure'),
          },
          {
            icon: <Icon.ICTune />,
            key: '3',
            onClick: null,
            tooltip: t('Customize'),
          },
        ]
      : [
          // {
          //   icon: <Icon.ICDuplicate />,
          //   key: "1",
          //   onClick: null,
          //   tooltip: "Nhân bản",
          // },
          {
            icon: <Icon.ICDesign />,
            key: '2',
            onClick: null,
            tooltip: t('Structure'),
          },
          {
            icon: <Icon.ICTune />,
            key: '3',
            onClick: null,
            tooltip: t('Customize'),
          },
        ];

  const findTopLevelParent = object => {
    let current = object;
    while (current?.parent && current?.parent?.type !== 'Scene') {
      current = current.parent;
    }
    return current;
  };

  return (
    <CSSTransition
      in={show}
      timeout={300}
      classNames="navbar-design-action"
      appear
    >
      <div className="navbar-design-action">
        <div className="navbar-design shadow-blueShadow border-[1px] border-solid border-outline-brand-primary rounded-[999px]">
          {items.map((item, i) => (
            <Tooltip key={i} title={item.tooltip} placement="top">
              {/* <ButtonIconGhostMedium
                key={i}
                icon={item.icon}
                onClick={() => {
                  if (item.onClick) item.onClick();
                  setActiveKey(item.key);
                }}
                className={activeKey === item.key && 'active'}
              /> */}
              <div
                className={cn(
                  'flex w-80 p-4 pb-2 flex-col items-center cursor-pointer rounded-[999px] transition-all duration-200 ease-linear hover:bg-primary-primaryFill hover:text-black-medium',
                  activeKey === item.key && 'bg-primary-primary text-white-high'
                )}
                onClick={() => {
                  if (item.onClick) item.onClick();
                  setActiveKey(item.key);
                }}
              >
                <span className="flex w-20 h-20 justify-center items-center gap-10">
                  {item.icon}
                </span>
                <span className="flex text-center line-clamp-1 truncate text-supporting-xl h-16 items-center justify-center">
                  {item.tooltip}
                </span>
              </div>
            </Tooltip>
          ))}
          <Divider
            type="vertical"
            style={{ marginInline: 0, top: 0, height: '32px' }}
          />
          <Tooltip title={t('Edit Doors')} placement="top">
            <div
              className={cn(
                'flex w-80 p-4 pb-2 flex-col items-center cursor-pointer rounded-[999px] transition-all duration-200 ease-linear hover:bg-primary-primaryFill hover:text-black-medium',
                activeKey === 'door-multiple-change' &&
                  'bg-primary-primary text-white-high'
              )}
              onClick={() => {
                setTick(t => t + 1);
                setActiveKey('door-multiple-change');
              }}
            >
              <span className="flex w-20 h-20 justify-center items-center gap-10">
                <Icon.ICDoorSetting />
              </span>
              <span className="flex text-center line-clamp-1 truncate text-supporting-xl h-16 items-center justify-center">
                {t('Edit Doors')}
              </span>
            </div>
          </Tooltip>
          <Divider
            type="vertical"
            style={{ marginInline: 0, top: 0, height: '32px' }}
          />
          <Tooltip title={t('Delete')} placement="top">
            <div
              className={cn(
                'flex w-80 p-4 pb-2 flex-col items-center cursor-pointer rounded-[999px] transition-all duration-200 ease-linear hover:bg-primary-primaryFill hover:text-black-medium'
              )}
              onClick={async () => {
                setActiveKey();
                setTick(t => t + 1);
                if (meshClickRef.current) {
                  const currentCabinet =
                    sceneManager.cabinetManager.getCurrentCabinet();

                  const model = findTopLevelParent(meshClickRef.current);
                  const foundModule = currentCabinet.getModuleByGroupUuid(
                    model.uuid
                  );

                  const cbGroup = foundModule?.group;
                  if (!cbGroup) return;

                  const picked = meshClickRef.current;

                  insideLoaderRef?.current?.removeInside(picked, foundModule);

                  //Xoá hộc kéo trong tủ thì xoá hết phần liên quan
                  if (
                    picked.userData.type === InsideType.DRAWER &&
                    picked.userData.isChildUDrawer === true &&
                    model
                  ) {
                    // Lọc để giữ lại các phần tử không phải là child drawer
                    foundModule.listInside.forEach(inside => {
                      if (
                        inside.gltf.userData?.isChildUDrawer === true ||
                        inside.type === InsideType.DOOR
                      ) {
                        if (
                          inside.type === InsideType.DOOR &&
                          inside.gltf.userData?.drawerUuid
                        ) {
                          insideLoaderRef?.current?.removeInside(
                            inside.gltf,
                            foundModule
                          );
                        } else if (
                          inside.gltf.userData?.isChildUDrawer === true
                        ) {
                          cbGroup.remove(inside.gltf);
                        }
                      }
                    });
                  }

                  //Xoá cửa hộc kéo trong tủ thì xoá hết các cửa hộc kéo trong tủ
                  if (
                    model &&
                    picked.userData.frameUuid &&
                    picked.userData.type === InsideType.DOOR
                  ) {
                    // Lọc để giữ lại các phần tử không phải là child drawer
                    foundModule.listInside.forEach(inside => {
                      if (
                        inside.gltf.userData?.frameUuid ===
                          picked.userData?.frameUuid &&
                        inside.type === InsideType.DOOR
                      ) {
                        insideLoaderRef?.current?.removeInside(
                          inside.gltf,
                          foundModule
                        );
                      }
                    });
                  }

                  meshClickRef.current = null;
                  childClickRef.current = null;

                  currentCabinet?.findPoint?.();
                  sceneRef.current?.removeAllPoints?.();
                  sceneRef.current?.display?.removeBoxes?.();
                  sceneRef.current?.display?.removePoints?.();
                  sceneRef.current?.removeWireframeBoxes?.();
                  sceneRef.current?.drawEdgeLine?.();
                  insideLoaderRef.current?.clearLine();
                  insideLoaderRef.current?.clearLabel();

                  setShowNavDesign(false);

                  setTick(t => t + 1);
                } else {
                  selectedModels.forEach(model => {
                    sceneManager.removeCabinetModule(model.uuid);
                    positionController.removeModule(model.uuid);
                  });
                  setSelectedModels([]);
                  setSelectedModel(null);
                }

                await sceneManager.calculateTotalCost?.({});
              }}
            >
              <span className="flex w-20 h-20 justify-center items-center gap-10">
                <Icon.ICDelete />
              </span>
              <span className="flex text-center line-clamp-1 truncate text-supporting-xl h-16 items-center justify-center">
                {t('Delete')}
              </span>
            </div>
          </Tooltip>

          {canSaveToLibrary(user) && cabinetType !== 'kitchen' && (
            <>
              <Divider
                type="vertical"
                style={{ marginInline: 0, top: 0, height: '32px' }}
              />

              <ButtonSecondaryMedium
                posIcon={<Icon.ICSave />}
                title={t('Save module')}
                style={{ borderRadius: '999px' }}
                onClick={async () => {
                  setActiveKey();
                  setTick(t => t + 1);
                  setShowSaveLibraryModule(true);
                }}
              />
            </>
          )}
        </div>
        <CSSTransition
          in={
            selectedModels &&
            selectedModels?.length > 1 &&
            !meshClickRef?.current
          }
          timeout={300}
          classNames="navbar-design-extra"
          appear
        >
          <div className="navbar-design-extra border-[1px] border-solid border-outline-default-primary rounded-[999px] bg-white">
            <Tooltip title={t('Align Horizontal Center')} placement="top">
              <div
                className={cn(
                  'flex w-60 p-4 pb-2 flex-col items-center cursor-pointer rounded-[999px] transition-all duration-200 ease-linear hover:bg-primary-primaryFill hover:text-black-medium focus:bg-primary-primary'
                )}
                onClick={() => {
                  setActiveKey();
                  setTick(t => t + 1);

                  insideLoaderRef.current.handleAlignModule(selectedModels);
                }}
              >
                <span className="flex w-20 h-20 justify-center items-center gap-10">
                  <Icon.ICAlignHorizontal />
                </span>
                <span className="flex text-center truncate text-supporting-xl h-16 items-center w-full">
                  {t('Align Horizontal Center')}
                </span>
              </div>
              {/* <ButtonIconGhostMedium
                icon={<Icon.ICAlignHorizontal />}
                onClick={async () => {}}
              /> */}
            </Tooltip>
          </div>
        </CSSTransition>
      </div>
    </CSSTransition>
  );
};

export default NavbarDesign;
